<template>
  <v-row justify="end" no-gutters class="fill-height">
    <v-col cols="12" lg="8" class="d-none d-lg-block">
      <div class="login-image"></div>
    </v-col>
    <v-col cols="12" lg="4" class="white d-flex align-center">
      <v-row justify="center">
        <v-col lg="9">
          <div class="text-center">
            <SvgLogo class="mx-auto mb-1" width="188" iconType="StrixLogo" />
            <SvgIcon
              class="primary--text mt-16"
              width="134"
              height="110"
              iconType="icon_envelope"
            />
            <h1
              class="secondary--text mt-10 mb-7 font-weight-black text-h4 mt-3"
            >
              {{ $t('portal.login.password_reset_succesfull.labels.title') }}
            </h1>
            <v-btn
              rounded
              outlined
              class="mt-10 tertiary white--text"
              style="height: 48px"
              :to="{ name: 'login' }"
              >{{
                $t(
                  'portal.login.password_reset_succesfull.labels.back_login_button'
                )
              }}</v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { SvgLogo } from '@leapsight/styleguide'

export default {
  name: 'PasswordResetSuccesfull',
  components: { SvgLogo },
  props: {},
  data() {
    return {}
  },
  methods: {},
  computed: {},
  watch: {}
  // Lifecycles
}
</script>

<style lang="scss" scoped>
.login-image {
  background-image: url('../../assets/bg-login.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-position: 0% 0%;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
